import { ModuleCardCode } from 'src/app/core/enums';

export interface ModuleCardDefinition {
  code: ModuleCardCode;
  title: string;
  icon: string;
  description?: string;
}

type ModuleCardsDictionary = Record<string, ModuleCardDefinition[]>;

const menuSetupCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.MenuSetupCategories,
    title: 'MENU_SETUP.MAIN_MENU_SETUP.MENU_CATEGORIES_TITLE',
    icon: 'receipt',
    description: 'MENU_SETUP.MAIN_MENU_SETUP.MENU_CATEGORIES_DETAIL',
  },
  {
    code: ModuleCardCode.MenuSetupMeals,
    title: 'MENU_SETUP.MAIN_MENU_SETUP.MENU_MEALS_TITLE',
    icon: 'receipt_long',
    description: 'MENU_SETUP.MAIN_MENU_SETUP.MENU_MEALS_DETAIL',
  },
];

const budgetManagementCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.BudgetManagementDashboard,
    title: 'BUDGET_MANAGEMENT.DASHBOARD',
    icon: 'dashboard',
    description: 'BUDGET_MANAGEMENT.DASHBOARD_DESCRIPTION',
  },
  {
    code: ModuleCardCode.BudgetManagementBudgetList,
    title: 'BUDGET_MANAGEMENT.BUDGET_LIST',
    icon: 'list',
    description: 'BUDGET_MANAGEMENT.BUDGET_LIST_DESCRIPTION',
  },
  {
    code: ModuleCardCode.BudgetManagementCreateBudget,
    title: 'BUDGET_MANAGEMENT.CREATE_BUDGET',
    icon: 'add_circle',
    description: 'BUDGET_MANAGEMENT.CREATE_BUDGET_DESCRIPTION',
  },
  {
    code: ModuleCardCode.BudgetManagementVarianceAnalysis,
    title: 'BUDGET_MANAGEMENT.VARIANCE_ANALYSIS',
    icon: 'analytics',
    description: 'BUDGET_MANAGEMENT.VARIANCE_ANALYSIS_DESCRIPTION',
  },
];

const shoppingManageAccountCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.ShoppingManageAccountProfile,
    title: 'SETUP_HOME.YOUR_ACCOUNT',
    icon: 'perm_contact_calendar',
    description: 'SETUP_HOME.YOUR_ACCOUNT_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountTheme,
    title: 'SETUP_HOME.THEME',
    icon: 'palette',
    description: 'SETUP_HOME.YOUR_THEME_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountBranches,
    title: 'SETUP_HOME.BRANCHES',
    icon: 'store',
    description: 'SETUP_HOME.BRANCHES_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountUserManagement,
    title: 'SIDENAV.USER_MANAGEMENT',
    icon: 'group',
    description: 'SETUP_HOME.USERS_MANAGEMENT',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPermissions,
    title: 'SETUP_HOME.PERMISSIONS_SETTINGS',
    icon: 'manage_accounts',
    description: 'SETUP_HOME.PERMISSIONS_SETTINGS_DESCRIPTION',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPrinterSettings,
    title: 'SETUP_HOME.PRINTER',
    icon: 'print',
    description: 'SETUP_HOME.PRINTER_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPaymentTerminalSettings,
    title: 'SETUP_HOME.PAYMENT_TERMINAL',
    icon: 'contactless',
    description: 'SETUP_HOME.PAYMENT_TERMINAL_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountEcommerceDashboard,
    title: 'SETUP_HOME.ECOMMERCE',
    icon: 'shopping_cart',
    description: 'SETUP_HOME.ECOMMERCE_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountCustomerInvoice,
    title: 'SETUP_HOME.CUSTOMER_INVOICE',
    icon: 'receipt',
    description: 'SETUP_HOME.CUSTOMER_INVOICE_DESCRIPTION',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountHospitality,
    title: 'SETUP_HOME.HOSPITALITY_MANAGEMENT',
    icon: 'hotel',
    description: 'SETUP_HOME.HOSPITALITY_MANAGEMENT_DESCRIPTION',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountMenuSetup,
    title: 'SETUP_HOME.MENU',
    icon: 'restaurant_menu',
    description: 'SETUP_HOME.MENU_DESCRIPTION',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountBranchFoodSetup,
    title: 'SETUP_HOME.DINING_AREA',
    icon: 'table_restaurant',
    description: 'SETUP_HOME.DINING_AREA_DESCRIPTION',
  },
];

const financeSettingCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.FinanceSettingBankAccounts,
    title: 'SETUP_HOME.BANK_ACCOUNTS',
    icon: 'account_balance',
    description: 'SETUP_HOME.INV_TRANS.BANK_ACCOUNTS_DESCRIPTION',
  },
  {
    code: ModuleCardCode.FinanceSettingBranchAccounts,
    title: 'SETUP_HOME.INV_TRANS.BRANCH_ACCOUNTS',
    icon: 'signal_cellular_alt',
    description: 'SETUP_HOME.INV_TRANS.BRANCH_ACCOUNTS_DETAILS',
  },
  {
    code: ModuleCardCode.FinanceSettingCostCenter,
    title: 'SETUP_HOME.INV_TRANS.COST_CENTER_NAME',
    icon: 'pie_chart',
    description: 'SETUP_HOME.INV_TRANS.COST_CENTER_DESCRIPTION',
  },
  {
    code: ModuleCardCode.FinanceSettingAssetCategory,
    title: 'SETUP_HOME.ASSETS_CATEGORY',
    icon: 'border_all',
    description: 'SETUP_HOME.ASSETS_CATEGORY_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingRateManagement,
    title: 'SETUP_HOME.RATE_MANAGEMENT',
    icon: 'currency_exchange',
    description: 'SETUP_HOME.RATE_MANAGEMENT_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingBankReconciliation,
    title: 'SETUP_HOME.BANK_RECONCILIATION',
    icon: 'published_with_changes',
    description: 'SETUP_HOME.BANK_RECONCILIATION_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingPostingProfile,
    title: 'SETUP_HOME.POSTING_PROFILE',
    icon: 'account_balance_wallet',
    description: 'SETUP_HOME.POSTING_PROFILE_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingBudgetManagement,
    title: 'SETUP_HOME.BUDGET_MANAGEMENT',
    icon: 'pie_chart_outline',
    description: 'SETUP_HOME.BUDGET_MANAGEMENT_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingZakatInvoice,
    title: 'SETUP_HOME.ZAKAT_INVOICE',
    icon: 'text_snippet',
    description: 'SETUP_HOME.ZAKAT_INVOICE_DESC',
  },
  {
    code: ModuleCardCode.FinanceSettingFixedAssets,
    title: 'SETUP_HOME.FIXED_ASSETS',
    icon: 'settings',
    description: 'SETUP_HOME.FIXED_ASSETS_DESC',
  },
];

const financeTransactionCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.FinanceTransactionPayableInvoice,
    title: 'SETUP_HOME.INV_TRANS.PAYABLE_INVOICE',
    icon: 'receipt',
    description: 'SETUP_HOME.INV_TRANS.PAYABLE_INVOICE_DETAILS',
  },
  {
    code: ModuleCardCode.FinanceTransactionJournals,
    title: 'SETUP_HOME.INV_TRANS.JOURNALS',
    icon: 'receipt_long',
    description: 'SETUP_HOME.INV_TRANS.JOURNALS_DETAILS',
  },
  {
    code: ModuleCardCode.FinanceTransactionCashTransfer,
    title: 'CASH_TRANSFER.TITLE',
    icon: 'payments',
    description: 'SETUP_HOME.CASH_TRANSFER_DESC',
  },
  {
    code: ModuleCardCode.FinanceTransactionBankReconciliation,
    title: 'SETUP_HOME.BANK_RECONCILIATION',
    icon: 'account_balance',
    description: 'SETUP_HOME.BANK_RECONCILIATION_DESC',
  },
  {
    code: ModuleCardCode.FinanceTransactionCustomerInvoices,
    title: 'CUSTOMER_INVOICES.TITLE',
    icon: 'receipt_long',
    description: 'SETUP_HOME.CASH_TRANSFER_DESC',
  },
  {
    code: ModuleCardCode.FinanceTransactionPeriodManagement,
    title: 'PERIOD_MANAGEMENT.TITLE',
    icon: 'date_range',
    description: 'PERIOD_MANAGEMENT.DESC',
  },
  {
    code: ModuleCardCode.FinanceTransactionFixedAssets,
    title: 'SETUP_HOME.INV_TRANS.FIXED_ASSETS',
    icon: 'pie_chart',
    description: 'SETUP_HOME.INV_TRANS.FIXED_ASSETS_DESC',
  },
];

const hrSetupCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.HrSetupDepartments,
    title: 'HR.DEPARTMENTS',
    icon: 'business',
    description: 'HR.DEPARTMENTS_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupJobs,
    title: 'HR.JOBS',
    icon: 'business_center',
    description: 'HR.JOBS_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupPositions,
    title: 'HR.POSITIONS',
    icon: 'badge',
    description: 'HR.POSITIONS_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupRecruitment,
    title: 'HR.RECRUITMENT',
    icon: 'people_alt',
    description: 'HR.RECRUITMENT_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupAnnouncements,
    title: 'HR.ANNOUNCEMENTG',
    icon: 'campaign',
    description: 'HR.ANNOUNCEMENTG_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupPayrollElements,
    title: 'HR.PAYROLL_ELEMENT',
    icon: 'credit_card',
    description: 'HR.PAYROLL_ELEMENT_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupPerformancePlans,
    title: 'HR.PERFORMANCE_PLANS',
    icon: 'speed',
    description: 'HR.PERFORMANCE_PLANS_DETAILS',
  },
  {
    code: ModuleCardCode.HrSetupLearningPlans,
    title: 'HR.Learning_plans',
    icon: 'school',
    description: 'HR.Learning_plans_Details',
  },
  {
    code: ModuleCardCode.HrSetupSelfServices,
    title: 'HR.REQUESTS_VACATIONS',
    icon: 'beach_access',
    description: 'HR.REQUESTS_VACATIONS_DESCRIPTION',
  },
  {
    code: ModuleCardCode.HrSetupPublicHolidays,
    title: 'COMMON.PUBLIC_HOLIDAYS',
    icon: 'pending_actions',
    description: 'COMMON.PUBLIC_HOLIDAYS_DESC',
  },
  {
    code: ModuleCardCode.HrSetupWorkflow,
    title: 'COMMON.WORKFLOW',
    icon: 'account_tree',
    description: 'COMMON.WORKFLOW_DESC',
  },
  {
    code: ModuleCardCode.HrSetupOrganizationHierarchy,
    title: 'COMMON.Organizational_Hierarchy',
    icon: 'device_hub',
    description: 'COMMON.Organizational_Hierarchy_DESC',
  },
];

const hrTransactionCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.HrTransactionEmployees,
    title: 'HR.EMPLOYEES',
    icon: 'recent_actors',
    description: 'HR.EMPLOYEES_DETAILS',
  },
  {
    code: ModuleCardCode.HrTransactionPrintEmployeeCard,
    title: 'COMMON.PRINT_EMP_CARD',
    icon: 'badge',
    description: 'HR.PRINT_EMP_CARD_DESC',
  },
  {
    code: ModuleCardCode.HrTransactionTimesheet,
    title: 'TIMESHEET.ATTENDANCE_TIMESHEET',
    icon: 'schedule',
    description: 'HR.TIME_SHEET_DETAILS',
  },
  {
    code: ModuleCardCode.HrTransactionPayroll,
    title: 'PAYROLL.TITLE',
    icon: 'account_balance_wallet',
    description: 'PAYROLL.PAYROLL_DETAILS',
  },
  {
    code: ModuleCardCode.HrTransactionPayslip,
    title: 'PAYSLIPS.PAYSLIP_LIST',
    icon: 'receipt',
    description: 'PAYSLIPS.PAYSLIP_DETAILS',
  },
  {
    code: ModuleCardCode.HrTransactionManagerHierarchy,
    title: 'HR.MANAGER_HIERARCHY',
    icon: 'account_tree',
    description: 'HR.MANAGER_HIERARCHY_DETAILS',
  },
];

const shoppingSetupCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.ShoppingSetupCategories,
    title: 'SETUP_HOME.CATEGORY_AND_SUBCATEGORY',
    icon: 'widgets',
    description: 'SETUP_HOME.CATEGORY_AND_SUBCATEGORY_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingSetupItems,
    title: 'SETUP_HOME.BROWSE_YOUR_ITEMS',
    icon: 'edit_note',
    description: 'SETUP_HOME.BROWSE_YOUR_ITEMS_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingSetupSuppliers,
    title: 'SETUP_HOME.SUPPLIERS',
    icon: 'local_shipping',
    description: 'SETUP_HOME.SUPPLIERS_DESCRIPTION',
  },
  {
    code: ModuleCardCode.ShoppingSetupBrands,
    title: 'SETUP_HOME.BRANDS',
    icon: 'local_offer',
    description: 'SETUP_HOME.BRANDS_DETAILS',
  },
];

const inventoryTransactionCards: ModuleCardDefinition[] = [
  {
    code: ModuleCardCode.ShoppingInventoryCustomerProduct,
    title: 'SETUP_HOME.SEARCH_YOUR_PRODUCTS',
    icon: 'query_stats',
    description: 'SETUP_HOME.SEARCH_PRODUCTS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryReceiving,
    title: 'SETUP_HOME.INV_TRANS.RECEVING',
    icon: 'local_shipping',
    description: 'SETUP_HOME.INV_TRANS.RECEVING_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryCountingOrder,
    title: 'SETUP_HOME.INV_TRANS.COUNTING-ORDER',
    icon: 'checklist',
    description: 'SETUP_HOME.INV_TRANS.COUNTING-ORDER_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryTransfer,
    title: 'SETUP_HOME.INV_TRANS.TRANSFER',
    icon: 'compare_arrows',
    description: 'SETUP_HOME.INV_TRANS.TRANSFER_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryPurchaseRequisition,
    title: 'SETUP_HOME.INV_TRANS.PURCH_REQ',
    icon: 'assignment',
    description: 'SETUP_HOME.INV_TRANS.PURCH_REQ_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryPurchaseOrders,
    title: 'SETUP_HOME.INV_TRANS.PRCHS_ORDERS',
    icon: 'shopping_cart_checkout',
    description: 'SETUP_HOME.INV_TRANS.PRCHS_ORDERS_DETAILS',
  },
  {
    code: ModuleCardCode.ShoppingInventoryBuyerWorkspace,
    title: 'SETUP_HOME.INV_TRANS.BUYER_WORKSPACE',
    icon: 'workspaces',
    description: 'SETUP_HOME.INV_TRANS.BUYER_WORKSPACE_DETAILS',
  },
];

function normalizeKey(text?: string): string | null {
  if (!text) {
    return null;
  }
  return text.trim().toLowerCase();
}

export const MODULE_CARDS_BY_SCREEN: ModuleCardsDictionary = {
  'pages/menu-setup': menuSetupCards,
  'pages/shopping-customer/manage-account': shoppingManageAccountCards,
  'pages/shopping-customer/setup-home': shoppingSetupCards,
  'pages/shopping-customer/inv-transaction': inventoryTransactionCards,
  'pages/finance/finance-setting': financeSettingCards,
  'pages/finance/finance-transaction': financeTransactionCards,
  'pages/finance/budget-management': budgetManagementCards,
  'pages/hr': hrSetupCards,
  'pages/hr/hr-transaction': hrTransactionCards,
  'finance setting': financeSettingCards,
  'finance settings': financeSettingCards,
  'finance transaction': financeTransactionCards,
  'chart of account': [],
  'chart of accounts': [],
  'human resource management': hrSetupCards,
  'human resources': hrSetupCards,
  'hr transaction': hrTransactionCards,
  'budget management': budgetManagementCards,
  'manage account': shoppingManageAccountCards,
  'menu setup': menuSetupCards,
  'inventory setup': shoppingSetupCards,
  'products and items': shoppingSetupCards,
  'inventory transaction': inventoryTransactionCards,
  'inventory and purchasing': shoppingSetupCards,
};

export function getModuleCardsByScreen(screen?: { routingPath?: string; nameEn?: string; nameAr?: string }): ModuleCardDefinition[] {
  const normalizedRoute = normalizeKey(screen?.routingPath?.replace(/^\/+/, ''));
  if (normalizedRoute && MODULE_CARDS_BY_SCREEN[normalizedRoute]) {
    return MODULE_CARDS_BY_SCREEN[normalizedRoute];
  }

  const normalizedName = normalizeKey(screen?.nameEn || screen?.nameAr);
  if (!normalizedName) {
    return [];
  }

  return MODULE_CARDS_BY_SCREEN[normalizedName] || [];
}

/**
 * Connects each visible module card to every route opened from that card.
 * Several editors use sibling routes instead of nesting below the card's
 * `urlNavigate`, so those siblings must be listed explicitly here.
 */
export interface ModuleCardRouteDefinition {
  code: ModuleCardCode;
  screenRoutingPath: string;
  routePrefixes: readonly string[];
  fallbackRoute: string;
  /** This destination is public or governed by its own screen/route guard. */
  unrestricted?: boolean;
}

export const MODULE_CARD_ROUTE_DEFINITIONS: readonly ModuleCardRouteDefinition[] = [
  // Menu setup
  {
    code: ModuleCardCode.MenuSetupCategories,
    screenRoutingPath: 'pages/menu-setup',
    routePrefixes: ['pages/menu-setup/menu-category', 'pages/menu-setup/form-menu-category'],
    fallbackRoute: '/pages/menu-setup',
  },
  {
    code: ModuleCardCode.MenuSetupMeals,
    screenRoutingPath: 'pages/menu-setup',
    routePrefixes: ['pages/menu-setup/meals'],
    fallbackRoute: '/pages/menu-setup',
  },

  // Finance settings
  {
    code: ModuleCardCode.FinanceSettingBankAccounts,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/finance-setups', 'pages/finance/add-edit-bank-account'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingBranchAccounts,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/branch-accounts'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingCostCenter,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/general-listing'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingAssetCategory,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/asset-category-list', 'pages/finance/add-asset-category'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingRateManagement,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/rate-management'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingPostingProfile,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/posting-profile'],
    fallbackRoute: '/pages/finance/finance-setting',
  },
  {
    code: ModuleCardCode.FinanceSettingBudgetManagement,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/budget-management'],
    fallbackRoute: '/pages/finance/finance-setting',
    unrestricted: true,
  },
  {
    code: ModuleCardCode.FinanceSettingZakatInvoice,
    screenRoutingPath: 'pages/finance/finance-setting',
    routePrefixes: ['pages/finance/setup-zakat'],
    fallbackRoute: '/pages/finance/finance-setting',
  },

  // Budget management (nested below Finance settings)
  {
    code: ModuleCardCode.BudgetManagementDashboard,
    screenRoutingPath: 'pages/finance/budget-management',
    routePrefixes: ['pages/finance/budget-management/dashboard'],
    fallbackRoute: '/pages/finance/budget-management',
  },
  {
    code: ModuleCardCode.BudgetManagementBudgetList,
    screenRoutingPath: 'pages/finance/budget-management',
    routePrefixes: [
      'pages/finance/budget-management/budget-list',
      'pages/finance/budget-management/budget-approval',
    ],
    fallbackRoute: '/pages/finance/budget-management',
  },
  {
    code: ModuleCardCode.BudgetManagementCreateBudget,
    screenRoutingPath: 'pages/finance/budget-management',
    routePrefixes: ['pages/finance/budget-management/budget-form'],
    fallbackRoute: '/pages/finance/budget-management',
  },
  {
    code: ModuleCardCode.BudgetManagementVarianceAnalysis,
    screenRoutingPath: 'pages/finance/budget-management',
    routePrefixes: ['pages/finance/budget-management/variance-analysis'],
    fallbackRoute: '/pages/finance/budget-management',
  },

  // Finance transactions
  {
    code: ModuleCardCode.FinanceTransactionPayableInvoice,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/finance/payable-invoice'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionJournals,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/finance/journal'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionCashTransfer,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/finance/cash-transfer'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionBankReconciliation,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/finance/bank-accounts-reconciliation'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionCustomerInvoices,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/customer-invoices'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionPeriodManagement,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: ['pages/finance/period-management'],
    fallbackRoute: '/pages/finance/finance-transaction',
  },
  {
    code: ModuleCardCode.FinanceTransactionFixedAssets,
    screenRoutingPath: 'pages/finance/finance-transaction',
    routePrefixes: [
      'pages/finance/fixed-assets-list',
      'pages/finance/fixed-asset',
      'pages/finance/asset-depreciation-history',
    ],
    fallbackRoute: '/pages/finance/finance-transaction',
  },

  // Human Resources setup (screen 72)
  {
    code: ModuleCardCode.HrSetupDepartments,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/departments'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupJobs,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/jobs'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupPositions,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/positions-setting'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupRecruitment,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/recruitment'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupAnnouncements,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/announcementlisting', 'pages/hr/addingannouncement'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupPayrollElements,
    screenRoutingPath: 'pages/hr',
    routePrefixes: [
      'pages/hr/payrollelementlisting',
      'pages/hr/payrollelementparameters',
      'pages/hr/payrollelement',
    ],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupPerformancePlans,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/planslistcomponent', 'pages/hr/creatnewplancomponent'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupLearningPlans,
    screenRoutingPath: 'pages/hr',
    routePrefixes: [
      'pages/hr/learningplanslist',
      'pages/hr/creatlearningplan',
      'pages/hr/courses',
    ],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupSelfServices,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/self-services', 'pages/hr/add-new-request'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupPublicHolidays,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/shopping-customer/calendar-exception'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupWorkflow,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/work-flow', 'pages/hr/add-work-flow'],
    fallbackRoute: '/pages/hr',
  },
  {
    code: ModuleCardCode.HrSetupOrganizationHierarchy,
    screenRoutingPath: 'pages/hr',
    routePrefixes: ['pages/hr/organization-hierarchy', 'pages/hr/organizationhierarchy'],
    fallbackRoute: '/pages/hr',
  },

  // Human Resources transactions (screen 78)
  {
    code: ModuleCardCode.HrTransactionEmployees,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/hr/customer-employees'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },
  {
    code: ModuleCardCode.HrTransactionPrintEmployeeCard,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/hr/print/card'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },
  {
    code: ModuleCardCode.HrTransactionTimesheet,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/hr/timesheet-setting'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },
  {
    code: ModuleCardCode.HrTransactionPayroll,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/hr/payroll'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },
  {
    code: ModuleCardCode.HrTransactionPayslip,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/hr/payslip'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },
  {
    code: ModuleCardCode.HrTransactionManagerHierarchy,
    screenRoutingPath: 'pages/hr/hr-transaction',
    routePrefixes: ['pages/manager-hierarchy'],
    fallbackRoute: '/pages/hr/hr-transaction',
  },

  // Inventory setup
  {
    code: ModuleCardCode.ShoppingSetupCategories,
    screenRoutingPath: 'pages/shopping-customer/setup-home',
    routePrefixes: [
      'pages/shopping-customer/customer-categories',
      'pages/shopping-customer/customer-categories-form',
    ],
    fallbackRoute: '/pages/shopping-customer/setup-home',
  },
  {
    code: ModuleCardCode.ShoppingSetupItems,
    screenRoutingPath: 'pages/shopping-customer/setup-home',
    routePrefixes: [
      'pages/shopping-customer/customer-items',
      'pages/shopping-customer/customer-items-form',
    ],
    fallbackRoute: '/pages/shopping-customer/setup-home',
  },
  {
    code: ModuleCardCode.ShoppingSetupSuppliers,
    screenRoutingPath: 'pages/shopping-customer/setup-home',
    routePrefixes: ['pages/shopping-customer/suppliers'],
    fallbackRoute: '/pages/shopping-customer/setup-home',
  },
  {
    code: ModuleCardCode.ShoppingSetupBrands,
    screenRoutingPath: 'pages/shopping-customer/setup-home',
    routePrefixes: [
      'pages/shopping-customer/customer-brands',
      'pages/shopping-customer/customer-brands-form',
    ],
    fallbackRoute: '/pages/shopping-customer/setup-home',
  },

  // Inventory and purchasing transactions
  {
    code: ModuleCardCode.ShoppingInventoryCustomerProduct,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/shopping-customer/customer-product'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryReceiving,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/inventory-receiving'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryCountingOrder,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/inventory/counting-order'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryTransfer,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/inventory-transfer'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryPurchaseRequisition,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/procurement/requisitions'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryPurchaseOrders,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/purchase-orders-listing', 'pages/purchase-orders-transaction'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },
  {
    code: ModuleCardCode.ShoppingInventoryBuyerWorkspace,
    screenRoutingPath: 'pages/shopping-customer/inv-transaction',
    routePrefixes: ['pages/buyer-workspace'],
    fallbackRoute: '/pages/shopping-customer/inv-transaction',
  },

  // Manage Account itself is an unguarded hub. Profile and tenant-security
  // destinations are exempt below; its other child routes still honor cards.
  {
    code: ModuleCardCode.ShoppingManageAccountProfile,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/user-management/user-profile'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
    unrestricted: true,
  },
  {
    code: ModuleCardCode.ShoppingManageAccountTheme,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/user-management/theme-customization'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountBranches,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: [
      'pages/shopping-customer/customer-branches',
      'pages/shopping-customer/add-edit-branch',
    ],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountUserManagement,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/user-management/user'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
    unrestricted: true,
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPermissions,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/permission-settings'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
    unrestricted: true,
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPrinterSettings,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/printer-settings'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountPaymentTerminalSettings,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: [
      'pages/shopping-customer/manage-account/payment-terminal-settings',
      'pages/shopping-customer/payment-terminal-settings',
    ],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountEcommerceDashboard,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/ecommerce-dashboard'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountCustomerInvoice,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    // Scope to the customer-invoice screens only. 'pages/invoices' also hosts
    // the public subscription-pricing pages (sub-prices / admin-sub-prices)
    // which must stay open to every customer and admin.
    routePrefixes: ['pages/invoices/invoices-list', 'pages/invoices/invoice-details'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountHospitality,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/hospitality-management'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountMenuSetup,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/menu-setup'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
    unrestricted: true,
  },
  {
    code: ModuleCardCode.ShoppingManageAccountBranchFoodSetup,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/branch-food-setup'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountApiDocumentation,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/manage-account/api-documentation'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountAiProviders,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: [
      'pages/shopping-customer/manage-account/ai-setup',
      'pages/shopping-customer/manage-account/ai-providers',
    ],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountAiAssistants,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/manage-account/ai-assistants'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
  {
    code: ModuleCardCode.ShoppingManageAccountAiUsage,
    screenRoutingPath: 'pages/shopping-customer/manage-account',
    routePrefixes: ['pages/shopping-customer/manage-account/ai-usage'],
    fallbackRoute: '/pages/shopping-customer/manage-account',
  },
];

